import makeThemedStyles from '../../components/Theme/makeThemedStyles';

const useStyles = makeThemedStyles(theme => ({
  saveLoad: {
    margin: theme.spacing(2, 0),
  },
}));

export default useStyles;
